import * as React from 'react';
import * as RadixSwitch from '@radix-ui/react-switch';

import { cn } from 'src/shared/helpers/utils';

export interface UISwitchProps
    extends Omit<React.ComponentPropsWithoutRef<typeof RadixSwitch.Root>, 'checked' | 'defaultChecked' | 'onCheckedChange'> {
    checked?: boolean;
    defaultChecked?: boolean;
    onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<React.ElementRef<typeof RadixSwitch.Root>, UISwitchProps>(({ className, ...props }, ref) => {
    return (
        <RadixSwitch.Root
            ref={ref}
            className={cn(
                'peer inline-flex h-3 w-8 shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary/40 data-[state=unchecked]:bg-grey-20',
                className
            )}
            {...props}
        >
            <RadixSwitch.Thumb
                className={cn(
                    'pointer-events-none block h-4 w-4 rounded-full shadow-md ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted-foreground'
                )}
            />
        </RadixSwitch.Root>
    );
});
Switch.displayName = 'Switch';

export { Switch };
